import axios from 'axios';

const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const getActiveCategories = () => {
    return axios.get(`${API_URL}shop/categories`);
}

export const API = {
    getActiveCategories
}